var _rect, _path, _rect2, _rect3, _circle, _circle2, _circle3, _path2, _rect4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.687 146.47H223C236.437 153.385 244.964 166.196 247.548 171.738L257.276 199H273.995L283.723 171.738C287.69 163.494 297.935 152.898 305.687 146.47Z",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 56,
    width: 82.6871,
    height: 97.2789,
    rx: 8,
    fill: "white",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 91.0205,
    width: 82.6871,
    height: 26.2653,
    rx: 8,
    fill: "#1C1B1F",
    stroke: "#1C1B1F",
    strokeWidth: 15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 263.501,
    cy: 369.499,
    r: 95.501,
    fill: "#1C1B1F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 263.501,
    cy: 369.499,
    r: 63.3322,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 222.284,
    cy: 366.483,
    r: 22.1158,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.513 285.01C232.43 260.976 252.777 242.221 262.336 235.849C293.471 244.588 300.8 272.264 300.573 285.01C303.304 321.608 274.854 326.66 260.288 324.612C228.606 320.788 225.237 296.617 227.513 285.01Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_226_9605",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 201,
    y: 214,
    width: 127,
    height: 127
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 201,
    y: 214,
    width: 127,
    height: 127,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_226_9605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.5 330.416C252.417 330.416 242.341 326.271 234.271 317.981C226.201 309.69 222.167 299.372 222.167 287.024C222.167 281.556 223.401 276.088 225.871 270.62C228.34 265.152 231.427 259.905 235.131 254.877C238.835 249.85 242.848 245.132 247.17 240.722C251.491 236.313 255.504 232.476 259.208 229.213C259.914 228.507 260.73 228 261.656 227.692C262.582 227.383 263.53 227.229 264.5 227.229C265.47 227.229 266.418 227.383 267.344 227.692C268.27 228 269.086 228.507 269.792 229.213C273.496 232.476 277.509 236.313 281.83 240.722C286.152 245.132 290.164 249.85 293.869 254.877C297.573 259.905 300.66 265.152 303.129 270.62C305.598 276.088 306.833 281.556 306.833 287.024C306.833 299.372 302.798 309.69 294.728 317.981C286.659 326.271 276.582 330.416 264.5 330.416ZM264.5 319.833C273.672 319.833 281.257 316.724 287.254 310.506C293.251 304.288 296.25 296.461 296.25 287.024C296.25 280.586 293.582 273.31 288.246 265.196C282.91 257.082 274.995 248.219 264.5 238.606C254.005 248.219 246.089 257.082 240.753 265.196C235.418 273.31 232.75 280.586 232.75 287.024C232.75 296.461 235.748 304.288 241.746 310.506C247.743 316.724 255.328 319.833 264.5 319.833ZM265.955 314.541C267.013 314.453 267.917 314.034 268.667 313.284C269.417 312.535 269.792 311.631 269.792 310.572C269.792 309.338 269.395 308.345 268.601 307.596C267.807 306.846 266.793 306.515 265.558 306.604C261.942 306.868 258.106 305.876 254.049 303.627C249.992 301.378 247.434 297.299 246.376 291.39C246.199 290.42 245.736 289.626 244.987 289.009C244.237 288.391 243.377 288.083 242.407 288.083C241.172 288.083 240.158 288.546 239.364 289.472C238.571 290.398 238.306 291.478 238.571 292.713C240.07 300.739 243.598 306.471 249.154 309.911C254.71 313.35 260.311 314.894 265.955 314.541Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/안과_결막염.f78b8f3cab3ab02e0d30f59e929554b6.svg";
export { ForwardRef as ReactComponent };